module.exports = __webpack_public_path__ + "img/report-3.4e23f97a.jpg";